export function copy2clipboard(txt: string) {
  if (navigator.clipboard) { // Chrome
    navigator.clipboard.writeText(txt + '').then(function() {
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
    });
  } else { // Internet Explorer
    const textArea = document.createElement('textarea');
    textArea.value = txt + '';

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'successful' : 'unsuccessful';
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  }
}

